'use strict';

angular.module('sfx.debug', ['sfx.data', 'support.supportService', 'sfx.security']);
